import { normalizeAlerts } from '@/function/calendar/calendar.alerts';
import type { TypeEvent, TypeEventPriority, TypeEventSnooze } from '@/types/calendar/types.calendar';

const PRIORITIES: TypeEventPriority[] = ['low', 'medium', 'high'];

const NO_SNOOZE: TypeEventSnooze = { count: 0, originalStartAt: null, lastAt: null };

const NO_LINKS: TypeEvent['webLinks'] = [];

const NO_FILES: TypeEvent['attachments'] = [];

type TypeLegacyEvent = TypeEvent & { reminderMinutes?: number | null };

export function normalizeEvent(incoming: TypeEvent): TypeEvent {
    const event = incoming as TypeLegacyEvent;
    const references = Array.isArray(event.references) ? event.references : [];
    const alerts = Array.isArray(event.alerts)
        ? event.alerts
        : normalizeAlerts(typeof event.reminderMinutes === 'number' ? [event.reminderMinutes] : []);
    const priority = PRIORITIES.includes(event.priority) ? event.priority : 'low';
    const snooze = event.snooze && typeof event.snooze.count === 'number' ? event.snooze : NO_SNOOZE;
    const webLinks = Array.isArray(event.webLinks) ? event.webLinks : NO_LINKS;
    const attachments = Array.isArray(event.attachments) ? event.attachments : NO_FILES;
    if (
        references === event.references && alerts === event.alerts && priority === event.priority && snooze === event.snooze
        && webLinks === event.webLinks && attachments === event.attachments && !('reminderMinutes' in event)
    ) return event;
    const { reminderMinutes: _legacy, ...rest } = event;
    return { ...rest, references, alerts, priority, snooze, webLinks, attachments };
}

export default normalizeEvent;
